/* eslint-disable */
import React, { Component } from 'react';
import TagManager from 'react-gtm-module';
import '../../assets/css/subscribe.css';
import {
  Currency,
  GA4Purchase,
  GTMPurchaseCompleted,
  GTM_ID,
} from '../../common/constant';
import FD from '../RestAPI/fetchData';
import App_data from '../config/App_data';
import Loader from '../../common/loader';
import { showFailure, showInformation } from '../../common/toast';
import { formatMoney, formatPrettyDate } from '../../utils/CommonUtils';

/* eslint-disable*/

class Thankyou extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      errorMessage: "",
      orderId: (props.params && props.params.order_id) || null,
      orderData: null,
      amount: 0,
      paymentType: "",
      createdAt: null,
    };

    this.loadUserOrder = this.loadUserOrder.bind(this);
    this.goToCourses = this.goToCourses.bind(this);

    // Idempotency guard so React strict-mode double-mount, page navigation
    // back, etc. cannot fire conversion tags twice for the same order_id.
    this._conversionFired = false;
  }

  componentDidMount() {
    if (!this.state.orderId) {
      this.setState({ isLoading: false, errorMessage: "Missing order id" });
      return;
    }
    this.loadUserOrder();
  }

  async loadUserOrder() {
    this.setState({ isLoading: true, errorMessage: "" });

    FD.callAPI(App_data.backend_api + "/checkout_v1/getOrdersbyid", { order_id: this.state.orderId })
      .then((resp) => {
        if (resp && resp.success) {
          let parsed = null;
          try {
            parsed = typeof resp.orders_val === "string"
              ? JSON.parse(resp.orders_val)
              : resp.orders_val;
          } catch (e) {
            parsed = null;
          }

          this.setState({
            isLoading: false,
            errorMessage: "",
            orderData: parsed,
            amount: Number(resp.amount) || 0,
            paymentType: resp.payment_type || "",
            createdAt: resp.createdAt || null,
          });

          // Fire conversion tags for marketing/analytics platforms.
          // Was lost when this component was rewritten alongside /createOrder
          // (#174 conversion-tracking regression). Must run for every
          // successful purchase that lands on /thankyou/:order_id.
          this.fireConversionTags({
            order: parsed,
            amount: Number(resp.amount) || 0,
            paymentType: resp.payment_type || "",
            stripeChargeId: resp.stripe_chargeID || null,
            stripeCustomerId: resp.stripe_customerID || null,
            payerId: resp.payer_id || null,
            paymentId: resp.payment_id || null,
            landingSource: resp.landingSource || 'organic',
            landingSourceName: resp.landingSourceName || null,
          });
        } else {
          const msg = (resp && resp.message) ? resp.message : "Failed to load your order";
          this.setState({ isLoading: false, errorMessage: msg });
          showInformation(msg);
        }
        return resp;
      })
      .catch((err) => {
        this.setState({ isLoading: false, errorMessage: "Error loading your order" });
        showFailure("Error loading your order");
      });
  }

  /**
   * Fire all post-purchase conversion tags. Idempotent: safe to call multiple
   * times for the same component instance — only the first call actually fires.
   *
   * Tags fired:
   *   - GTM `purchaseCompleted` (custom dataLayer event for the GTM workspace)
   *   - GTM `purchase` (GA4 standard ecommerce event)
   *   - Bing UET (window.uet_report_conversion, defined in public/index.html)
   *   - Tapfiliate `conversion` (Stripe transaction id, with PayPal fallback)
   */
  fireConversionTags({
    order,
    amount,
    paymentType,
    stripeChargeId,
    stripeCustomerId,
    payerId,
    paymentId,
    landingSource,
    landingSourceName,
  }) {
    if (this._conversionFired) return;
    if (!order || !Array.isArray(order.all_order_details)) return;
    if (!amount || amount <= 0) return;
    this._conversionFired = true;

    try {
      const cart = order.all_order_details.map((item) => {
        const extras = Array.isArray(item.extras) ? item.extras : [];
        const extrasTotal = extras.reduce((s, e) => s + (Number(e.price) || 0), 0);
        return {
          exam: item.exam_name || '',
          packageType: item.package_type || '',
          price: (Number(item.price) || 0) + extrasTotal,
        };
      });

      const transactionId = order.order_id != null ? String(order.order_id) : '';

      const commonData = {
        transaction_id: transactionId,
        value: amount,
        currency: Currency,
        userName: order.username || '',
        userEmail: order.idname || '',
        source: landingSource,
      };

      const paymentOption = paymentType === 'stripe' ? 'card' : (paymentType || '');

      // GTM custom event (existing GTM tags listen to `purchaseCompleted`)
      TagManager.initialize({
        gtmId: GTM_ID,
        dataLayer: {
          event: GTMPurchaseCompleted,
          eventOptions: {
            orderID: commonData.transaction_id,
            paymentOption,
            cart,
            cartTotal: amount,
          },
          ...commonData,
          price: amount,
          affiliateName: landingSourceName,
        },
      });

      // GA4 standard ecommerce purchase event
      TagManager.initialize({
        gtmId: GTM_ID,
        dataLayer: {
          event: GA4Purchase,
          eventOptions: {
            orderID: commonData.transaction_id,
            paymentOption,
            cart,
            cartTotal: amount,
          },
          ...commonData,
          revenue_value: amount,
          affiliation: landingSourceName,
          items: cart,
        },
      });

      // Bing UET conversion (helper defined in public/index.html)
      if (typeof window !== 'undefined' && typeof window.uet_report_conversion === 'function') {
        window.uet_report_conversion(amount);
      }

      // Tapfiliate conversion (Stripe primary, PayPal fallback). Re-creates
      // the integration handle defensively in case the page entered Thankyou
      // without coming from the public landing pages where it was created.
      if (typeof window !== 'undefined' && typeof window.tap === 'function') {
        if (paymentType === 'stripe' && stripeChargeId) {
          try { window.tap('create', '14886-4db9dd', { integration: 'stripe' }); } catch (e) {}
          window.tap('conversion', stripeChargeId, amount, {
            customer_id: stripeCustomerId || undefined,
          });
        } else if (paymentType === 'paypal' && paymentId) {
          try { window.tap('create', '14886-4db9dd', { integration: 'paypal' }); } catch (e) {}
          window.tap('conversion', paymentId, amount, {
            customer_id: payerId || undefined,
          });
        }
      }

      // Facebook Pixel — purchase event with currency + value
      if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
        window.fbq('track', 'Purchase', {
          currency: Currency,
          value: amount,
        });
      }
    } catch (e) {
      // Never let an analytics failure break the user-visible Thank You page.
      // eslint-disable-next-line no-console
      console.warn('Thankyou conversion tags failed:', e && e.message);
    }
  }

  goToCourses() {
    this.props.router.push("/dashboard");
  }

  isUpgradeItem(item) {
    return item && item.type && String(item.type).startsWith("upgrade_");
  }

  getOrderTotals(items) {
    let subtotal = 0;
    let discountTotal = 0;
    let firstPct = 0;

    for (let i = 0; i < items.length; i++) {
      const it = items[i];
      const extras = Array.isArray(it.extras) ? it.extras : [];
      const addonsTotal = extras.reduce((s, e) => s + (Number(e.price) || 0), 0);
      const basePrice = Number(it.price) || 0;
      const planPriceOnly = Math.max(0, basePrice - addonsTotal);
      const pct = Number(it.percent_discount) || 0;
      const discountAmt = pct > 0 ? (planPriceOnly * pct) / 100 : 0;

      subtotal += basePrice;
      discountTotal += discountAmt;
      if (pct > 0 && firstPct === 0) firstPct = pct;
    }

    return { subtotal, discountTotal, firstPct };
  }

  renderItem(item, idx) {
    const isUpgrade = this.isUpgradeItem(item);
    const isUpgradeUnlimited = isUpgrade && item.type === "upgrade_unlimited";
    const examName = item.exam_name || "";
    const pkgType = item.package_type || "";
    const extras = Array.isArray(item.extras) ? item.extras : [];
    const addonsTotal = extras.reduce((s, e) => s + (Number(e.price) || 0), 0);

    // item.price is basePrice (plan + addons); back out the plan-only price
    const basePrice = Number(item.price) || 0;
    const planPriceOnly = Math.max(0, basePrice - addonsTotal);
    const pctDiscount = Number(item.percent_discount) || 0;
    // Discount only applies to plan price (#243), not to add-ons
    const discountAmount = pctDiscount > 0 ? (planPriceOnly * pctDiscount) / 100 : 0;
    // const finalPrice = Math.max(0, planPriceOnly - discountAmount);

    const abbr = examName ? examName.substring(0, 3).toUpperCase() : "";
    const upgradeBadgeClass = "ty_item_badge " + (isUpgradeUnlimited ? "ty_item_badge_green" : "ty_item_badge_blue");

    return (
      <div key={idx} className="ty_item_block">
        <div className="ty_item_row">
          <div className="ty_item_left">
            <div className="ty_item_icon">
              <span className="ty_item_icon_text">{abbr}</span>
            </div>
            <div className="ty_item_text">
              <div className="ty_item_title_box">
                <p className="ty_item_title">
                  {isUpgrade ? examName + " – Upgrade to " + pkgType : examName}
                </p>
                {!isUpgrade && pkgType ? <p className="ty_item_subtitle">({pkgType})</p> : null}
                {isUpgrade ? <span className={upgradeBadgeClass}>UPGRADE</span> : null}
              </div>
            </div>
          </div>
          <div className="ty_item_right">
            {/* <div className="ty_item_price">{formatMoney(finalPrice)}</div> */}
            <div className="ty_item_price">{formatMoney(planPriceOnly)}
              {item.payment_interval ? <span className="ct_item_price_interval">/{item.payment_interval} </span> : ""}
            </div>
          </div>
        </div>

        {discountAmount > 0 ? (
          <div className="ty_discount_row">
            <span className="ty_discount_label">Coupon applied (-{pctDiscount}%)</span>
            <span className="ty_discount_value">-{formatMoney(discountAmount)}</span>
          </div>
        ) : null}

        {extras.length > 0 ? (
          <div className="ty_addons_box">
            {extras.map((ex, i) => (
              <div key={i} className="ty_addon_row">
                <div className="ty_addon_name">
                  <span className="ty_addon_tree">└</span>{ex.title}
                  <span className="ty_addon_badge">ADD-ON</span>
                </div>
                <div className="ty_addon_price">
                  {Number(ex.price) > 0 ? formatMoney(Number(ex.price)) : (
                    <span className="ty_addon_included">Included</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const { isLoading, errorMessage, orderData, amount, paymentType, createdAt, orderId } = this.state;

    if (isLoading) {
      return (
        <div className="animated fadeIn">
          <Loader />
        </div>
      );
    }

    if (errorMessage) {
      return (
        <div className="animated fadeIn">
          <div className="sb_page_container">
            <div className="sb_error_message">{errorMessage}</div>
          </div>
        </div>
      );
    }

    const items = (orderData && Array.isArray(orderData.all_order_details))
      ? orderData.all_order_details
      : [];

    const username = (orderData && orderData.username) || "";
    const email = (orderData && orderData.idname) || "";
    const orderNumber = (orderData && orderData.order_id) || orderId || "";
    const dateText = createdAt ? formatPrettyDate(createdAt) : "";
    const paymentLabel = paymentType === "stripe" ? "Credit / Debit Card" : (paymentType || "—");

    return (
      <div className="animated fadeIn">
        <div className="sb_page_container">
          <div className="ty_title_block">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ty_check_icon">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="m9 12 2 2 4-4"></path>
            </svg>
            <h1 className="ty_title">Your order was successful!</h1>
            <p className="ty_order_number_title">Order number: {orderNumber}</p>
            <p className="ty_subtitle">
              Your order information, along with a detailed receipt, have been emailed to you.
            </p>
            <button
              type="button"
              className="ct_btn_checkout"
              onClick={this.goToCourses}
            >
              Access My Learning
            </button>
          </div>

          <div className="ty_block_divider" />

          <div className="ty_layout">
            <div>
              <h2 className="ty_card_title">Order Summary</h2>
              <div className="ty_card">

                <div className="ty_items_list">
                  {items.length > 0
                    ? items.map((it, i) => this.renderItem(it, i))
                    : <p className="ty_muted">No items.</p>
                  }
                </div>

                {(() => {
                  const { subtotal, discountTotal, firstPct } = this.getOrderTotals(items);
                  return (
                    <div className="ty_totals_box">
                      <div className="ty_subtotal_row">
                        <span>Subtotal:</span>
                        <span>{formatMoney(subtotal)}</span>
                      </div>
                      {discountTotal > 0 ? (
                        <div className="ty_discount_total_row">
                          <span>Discount: {firstPct > 0 ? `(-${firstPct}%)` : ""}</span>
                          <span>-{formatMoney(discountTotal)}</span>
                        </div>
                      ) : null}
                    </div>
                  );
                })()}

                <div className="ty_total_row">
                  <span>Total</span>
                  <span className="ty_total_amount">{formatMoney(amount)}</span>
                </div>
              </div>
            </div>

            <div className="ty_col_right">
              <h2 className="ty_card_title">Order Details</h2>
              <div className="ty_card">

                <div className="ty_details_row">
                  <span className="ty_details_label">Order #</span>
                  <span className="ty_details_value">{orderNumber}</span>
                </div>
                {dateText ? (
                  <div className="ty_details_row">
                    <span className="ty_details_label">Date</span>
                    <span className="ty_details_value">{dateText}</span>
                  </div>
                ) : null}
                <div className="ty_details_row">
                  <span className="ty_details_label">Name</span>
                  <span className="ty_details_value">{username}</span>
                </div>
                <div className="ty_details_row">
                  <span className="ty_details_label">Email</span>
                  <span className="ty_details_value">{email}</span>
                </div>
                <div className="ty_details_row">
                  <span className="ty_details_label">Payment</span>
                  <span className="ty_details_value">{paymentLabel}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


/* class Thankyou extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      succ_img: 'http://localhost:3000/img/green_checked.png',
      order_id: this.props.params.order_id,
      token: '',
      idname: '',
      ValidToken: false,
      orders_discription: [],
      totalAmount: '',
      order_price: [],
      uts_orderid: this.props.params.order_id,
      payment_type: '',
      stripe_customerID: '',
      stripe_chargeID: '',
      payer_id: '',
      payment_id: '',
      landingSource: 'organic',
      landingSourceName: null,
      exam: null,
      isLoading: true,
    };
  }

  componentDidMount() {
    const session = JSON.parse(localStorage.getItem('localstorageval'));
    if (session) {
      this.setState({
        idname: session.idname,
        token: session.token,
      });
    }

    const data = {
      idname: session.idname,
      token: session.token,
      order_id: this.state.order_id,
    };

    FD.callAPI(`${App_data.backend_api}/checkout_v1/getOrdersbyid`, data).then(async (resp) => {
      if (resp.success) {
        const app1 = JSON.stringify(resp.orders_val);
        const app2 = JSON.parse(JSON.parse(app1));
        this.setState({
          ValidToken: true,
          orders_discription: app2,
          totalAmount: resp.amount,
          order_price: app2.all_order_details,
          payment_type: resp.payment_type,
          stripe_customerID: resp.stripe_customerID,
          stripe_chargeID: resp.stripe_chargeID,
          payer_id: resp.payer_id,
          payment_id: resp.payment_id,
          landingSource: resp.landingSource,
          landingSourceName: resp.landingSourceName,
          exam: resp.exam,
          isLoading: false,
        });

        const gtmData = {
          orders_discription: app2,
          totalAmount: resp.amount,
          order_price: app2.all_order_details,
          payment_type: resp.payment_type,
          landingSource: resp.landingSource,
          landingSourceName: resp.landingSourceName,
        };

        if (window.uet_report_conversion) {
          window.uet_report_conversion(resp.amount);
        }

        await this.triggerGTM(gtmData);
      } else {
        this.setState({ ValidToken: false });
      }
    });
  }

  triggerGTM = (data) => {
    const array = data.order_price.map((item) => {
      let extraPrice = item.price;
      if (item.extras && item.extras.length) {
        extraPrice += item.extras.reduce((sum, e) => sum + e.price, 0);
      }
      return {
        exam: item.exam_name,
        packageType: item.package_type,
        price: extraPrice,
      };
    });

    const commonData = {
      transaction_id: JSON.stringify(data.orders_discription.order_id),
      value: data.totalAmount,
      currency: Currency,
      userName: data.orders_discription.username,
      userEmail: data.orders_discription.idname,
      source: data.landingSource,
    };

    TagManager.initialize({
      gtmId: GTM_ID,
      dataLayer: {
        event: GTMPurchaseCompleted,
        eventOptions: {
          orderID: commonData.transaction_id,
          paymentOption: data.payment_type === 'stripe' ? 'card' : data.payment_type,
          cart: array,
          cartTotal: data.totalAmount,
        },
        ...commonData,
        price: data.totalAmount,
        affiliateName: data.landingSourceName,
      },
    });

    TagManager.initialize({
      gtmId: GTM_ID,
      dataLayer: {
        event: GA4Purchase,
        eventOptions: {
          orderID: commonData.transaction_id,
          paymentOption:
            data.orders_discription.payment_type === 'stripe'
              ? 'card'
              : data.orders_discription.payment_type,
          cart: array,
          cartTotal: data.totalAmount,
        },
        ...commonData,
        revenue_value: data.totalAmount,
        affiliation: data.landingSourceName,
        items: array,
      },
    });
  };

  render() {
    const payment_details = this.state.orders_discription;
    let payment_details_val = '';
    const plan_details = this.state.order_price;

    let data1 = '';
    payment_details_val = (
      <table className='table cart_table'>
        <tbody>
          <tr>
            <td>
              <strong>{language.LC().ORDER_ID} :</strong>
            </td>
            <td>{payment_details.order_id}</td>
          </tr>
          <tr>
            <td>
              <strong>{language.LC().NAME} :</strong>
            </td>
            <td>{payment_details.username}</td>
          </tr>
          <tr>
            <td>
              <strong>{language.LC().PAYMENT_METHOD} :</strong>
            </td>
            <td>{payment_details.payment_type}</td>
          </tr>
          <tr>
            <td>
              <strong>{language.LC().EMAIL} :</strong>
            </td>
            <td>{payment_details.idname}</td>
          </tr>
        </tbody>
      </table>
    );

    if (plan_details.length) {
      data1 = Object.keys(plan_details).map((item, index) => (
        <tbody key={index}>
          <tr className='package-heading'>
            <td width='60%'>
              {`${plan_details[index].exam_name} (${plan_details[index].package_type}) `}
            </td>
            <td width='20%'>
              {plan_details[index].type !== 'unlessUnlimited'
                ? `$${plan_details[index].price}`
                : null}
            </td>
            <td width='20%'>
              {plan_details[index].type !== 'unlessUnlimited'
                ? `$${
                    // eslint-disable-next-line eqeqeq
                    plan_details[index].percent_discount == 0
                      ? plan_details[index].percent_discount
                      : Math.ceil(
                          plan_details[index].price * plan_details[index].percent_discount,
                        ) / 100
                  }`
                : null}
            </td>
          </tr>
          {plan_details[index].extras.map((extras, key) => {
            return (
              <tr key={key} className='extras-table'>
                <td width='60%'>{`- ${extras.title}`}</td>
                <td width='20%'>${extras.price}</td>
                <td width='20%' />
              </tr>
            );
          })}
        </tbody>
      ));
    }
    const total = this.state.totalAmount;
    let tot_price = 0;
    if (plan_details.length) {
      Object.keys(plan_details).map((item, index) => {
        if (plan_details[index].percent_discount === '') {
          // eslint-disable-next-line no-multi-assign
          tot_price += tot_price += Math.round(plan_details[index].price);
        } else {
          tot_price += Math.round(
            plan_details[index].price -
              Number((plan_details[index].price * plan_details[index].percent_discount) / 100),
          );
        }
      });

      // eslint-disable-next-line no-var
      var order_fetch = payment_details.order_id;
    }
    const tagManagerArgs = {
      gtmId: GTM_ID,
      events: {
        sendUserInfo: GTMUserInfo,
      },
      dataLayer: {
        page: 'checkout',
        value: total,
        currency: 'USD',
      },
    };
    TagManager.initialize(tagManagerArgs);

    const { payment_type, stripe_chargeID, stripe_customerID, totalAmount, payer_id, payment_id } =
      this.state;
    let tapFiliateCount = 0;
    {
      payment_type === 'stripe' ? (
        <script src='https://script.tapfiliate.com/tapfiliate.js' type='text/javascript' async>
          {tapFiliateCount++}
          <script type='text/javascript'>
            {function (t, a, p) {
              (t.TapfiliateObject = a),
                (t[a] =
                  t[a] ||
                  function () {
                    (t[a].q = t[a].q || []).push(arguments);
                  });
            }}
            )({(window, 'tap')});
            {
              (window.tap('create', '14886-4db9dd', {
                integration: 'stripe',
              }),
              window.tap('conversion', stripe_chargeID, totalAmount, {
                customer_id: stripe_customerID,
              }))
            }
          </script>
        </script>
      ) : null;
    }

    {
      payment_type === 'paypal' ? (
        <script src='https://script.tapfiliate.com/tapfiliate.js' type='text/javascript' async>
          <script type='text/javascript'>
            {(function (t, a, p) {
              t.TapfiliateObject = a;
              t[a] =
                t[a] ||
                function () {
                  (t[a].q = t[a].q || []).push(arguments);
                };
            })(window, 'tap')}
            ;{window.tap('create', '14886-4db9dd', { integration: 'paypal' })};
            {window.tap('conversion', payment_id, totalAmount, {
              customer_id: payer_id,
            })}
          </script>
        </script>
      ) : null;
    }

    const { isLoading } = this.state;
    return (
      <div className='animated fadeIn'>
        <Helmet
          script={[
            {
              src: 'https://www.dwin1.com/19038.js',
              type: 'text/javascript',
              defer: 'defer',
            },
          ]}
        />
        <img
          src={`https://www.shareasale.com/sale.cfm?tracking=${order_fetch}&amount=${tot_price}&merchantID=118265&transtype=sale&currency=USD`}
          width='1'
          height='1'
        />
        <div className='row'>
          <div className='col-xs-12 col-sm-12 col-md-12'>
            <div className='white_box margin_bottom_20'>
              <div className='row'>
                <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10'>
                  <h4> {language.LC().THANK_YOU_FOR_YOUR_ORDER}</h4>
                </div>
              </div>

              {isLoading ? (
                <Loader />
              ) : (
                <div className='row'>
                  <div className='col-xs-12 col-sm-6 col-md-7 margin_bottom_10'>
                    <div className='table-responsive thankyou_tb'>
                      <table className='table cart_table '>
                        <thead>
                          <tr>
                            <th>{language.LC().PACKAGE}</th>
                            <th>{language.LC().PRICE}</th>
                            <th>{language.LC().DISCOUNT}</th>
                          </tr>
                        </thead>
                        {data1}
                        <tfoot>
                          <tr>
                            <td>
                              <strong>{language.LC().TOTAL}</strong>
                            </td>

                            <td>${total}</td>

                            <td />
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  <div className='col-xs-12 col-sm-6 col-md-5 margin_bottom_10'>
                    <div className='table-responsive thankyou_tb'>{payment_details_val}</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
} */

export default Thankyou;



// WEBPACK FOOTER //
// ./src/views/Thankyou/Thankyou.js